import React from "react";
import styled from "styled-components/macro";
import { JobCard } from "./job_card";
import { theme } from "./theme";

const JobTableView = ({
  jobs,
  printers,
  jobSelected,
  onJobClick,
  renderColor,
  selectedIds,
  onToggleCheck,
  onOpenPrinter,
}) => {
  if (!jobs.length) {
    return <Empty>No jobs match your filters.</Empty>;
  }

  return (
    <Wrapper>
      {jobs.map((item) => (
        <JobCard
          key={item.id}
          renderColor={renderColor}
          printer={printers?.[item.printer_id]}
          doc={item}
          jobSelected={jobSelected}
          onJobClick={onJobClick}
          selectable
          checked={selectedIds.has(item.id)}
          onToggleCheck={onToggleCheck}
          onOpenPrinter={onOpenPrinter}
        />
      ))}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const Empty = styled.div`
  padding: 40px 0;
  text-align: center;
  color: ${theme.textMuted};
  font-size: 14px;
  font-family: ${theme.fontFamily};
`;

export { JobTableView };
